<template>
    <div class="pta-admin">
        <div class="page-titles border-bottom">
            <h3>Transcripts - AI Test</h3>
            <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/transcripts')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">{{trans('transcript.transcript_list')}}</span></button>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
          <div style="width:50%;float:left">
              <div class="row" style="background:#fff;border-radius:20px;padding:20px 20px 40px;">
                  <div class="col-12 col-sm-12" style="margin-bottom:20px;margin-top:20px;">
                    <textarea :readonly="is_run" class="form-control" v-model="transcriptForm.text" style="height:500px"></textarea>
                  </div>
                  <div class="col-12 col-sm-12">
                    <button v-if="!is_run" type="button" @click.prevent="sendText" class="btn btn-info">Start AI Test</button>
                    <button v-if="is_run" type="button" @click.prevent="resetText" class="btn btn-info">Reset</button>
                  </div>
              </div>
          </div>
          <div style="width:50%;float:left;padding:0 0 0 40px;">
            <div style="background:#fff;border-radius:20px;padding:40px;min-height:638px;">
              <div v-if="is_run">
                <img src="/images/11-38-42-66_512.webp" style="max-width:400px;width:80%;margin:50px auto 0;opacity:0.2;display:block;" />
                <center>The AI process is running. Please wait.</center>
              </div>
              <div v-if="is_ready" class="pta-ai-results">
                <table cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                    <td width="140">ESG</td><td v-text="transscript.esg?transscript.esg:'-'"></td>
                  </tr>
                  <tr>
                    <td>FTF</td><td v-text="transscript.ftf?transscript.ftf:'-'"></td>
                  </tr>
                  <tr>
                    <td>Fundtype</td><td v-text="transscript.fundtype?transscript.fundtype:'-'"></td>
                  </tr>
                  <tr>
                    <td>Geography</td><td v-text="transscript.geography?transscript.geography:'-'"></td>
                  </tr>
                  <tr>
                    <td>Invstructure</td><td v-text="transscript.invstructure?transscript.invstructure:'-'"></td>
                  </tr>
                  <tr>
                    <td>Policy</td><td v-text="transscript.policy?transscript.policy:'-'"></td>
                  </tr>
                  <tr>
                    <td>Summary</td><td v-text="transscript.summary?transscript.summary:'-'"></td>
                  </tr>
                  <tr>
                    <td>Ticketsize</td><td v-text="transscript.ticketsize?transscript.ticketsize:'-'"></td>
                  </tr>
                  <tr>
                    <td>Holding period</td><td v-text="transscript.period?transscript.period:'-'"></td>
                  </tr>
                </table>
              </div>
            </div>

          </div>
          <div style="clear:left"></div>
        </div>
    </div>
</template>
<script>
    export default {
        components : {  },
        data() {
            return {
              transcriptForm: new Form({
                text: '',
              },false),
              transcriptError: {
                error: '',
              },
              is_run: false,
              is_ready:false,
              uuid: '',
              transscript: ''
            };
        },
        mounted(){
         // this.uuid = 'bb346ff3-de6e-45ae-a33f-9f0fbf661705';
        //  this.getValues();
        },
        methods: {
          sendText(){
            if(this.transcriptForm.text!=""){
              this.is_ready = false;
              this.is_run = true;
              this.transcriptForm.post('/api/transcript/ai-test')
                  .then(response => {
                    this.uuid = response.uuid;

                    setTimeout(this.getValues, 10000);
                    toastr.success(response.message);
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                  });
            }
          },
          getValues(){
            axios.get('/api/transcript/ai-values/'+this.uuid)
                .then(response => response.data)
                .then(response => {
                  if(response != "NOK"){
                    this.transscript = response;
                    if(response.status == "Not an investor transcript"){
                      this.is_run = false;
                      this.transcriptError.error = response.status;
                      helper.showDataErrorMsg(this.transcriptError);
                    }else{
                      this.is_run = false;
                      this.is_ready = true;
                    }
                  }else{
                    setTimeout(this.getValues, 10000);
                  }
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          resetText(){
            this.is_run = false;
            this.transcriptForm.text = '';
          }
        },
        filters: {

        }
    }
</script>
<style>
.pta-ai-results table td{
  font-size:0.8em;
  line-height:1.25em;
  padding:8px;
  vertical-align:top;
}
.pta-ai-results table tr:nth-child(odd){
  background:#efefef;
}
</style>
